var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("物流订单")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.type == 0 ? _c("h2", [_vm._v("原订单拆单")]) : _vm._e(),
          _vm.type == 1 ? _c("h2", [_vm._v("母订单拆单")]) : _vm._e(),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", { staticStyle: { "line-height": "36px" } }, [
                _vm._v("订单商品 "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#4168E7",
                      "margin-left": "12px",
                      "font-size": "14px",
                    },
                  },
                  [_vm._v("订单编号（" + _vm._s(_vm.orderNo) + "）")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#4168E7",
                      "margin-left": "12px",
                      "font-size": "14px",
                    },
                  },
                  [_vm._v("代收金额￥" + _vm._s(_vm.totalAmount))]
                ),
              ]),
              _c("div", { staticClass: "aBtn", on: { click: _vm.add } }, [
                _vm._v("增加拆单"),
              ]),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                border: "",
                data: _vm.goods,
                "header-cell-style": {
                  background: "#F5F6FA",

                  color: "#303033",
                },
              },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { label: "商品", prop: "type", align: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c("div", [
                              _c("img", {
                                staticStyle: { width: "106px", height: "80px" },
                                attrs: { src: props.row.goodsImg },
                              }),
                            ]),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-left": "8px",
                                    "font-size": "14px",
                                    "font-family": "PingFang SC",
                                    "font-weight": "bold",
                                    "line-height": "22px",
                                    color: "#333333",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.originGoodsName)
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { "text-align": "left" } }, [
                        _vm._v("商品"),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "商品规格", prop: "type", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(_vm._s(props.row.goodsSkuName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", prop: "type", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(_vm._s(props.row.quantity)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "拆单已选", prop: "type", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(_vm._s(props.row.splitQuantity)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._l(_vm.splitOrderList, function (item, index) {
            return _c(
              "div",
              { key: index, staticStyle: { "margin-top": "10px" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "16px",
                            height: "16px",
                            background: "#4168E7",
                            "border-radius": "50%",
                            opacity: "1",
                            "font-size": "14px",
                            "font-family": "PingFang SC",
                            "font-weight": "400",
                            "line-height": "16px",
                            color: "#FFFFFF",
                            "text-align": "center",
                            "margin-top": "12px",
                          },
                        },
                        [_vm._v(" " + _vm._s(index + 1))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "40px",
                            "margin-left": "2px",
                          },
                        },
                        [_vm._v("拆单订单" + _vm._s(index + 1))]
                      ),
                      _vm.type == 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "40px",
                                "margin-left": "2px",
                                color: "#4168E7",
                                "font-size": "14px",
                              },
                            },
                            [
                              _vm._v(
                                " 母订单编号：" +
                                  _vm._s(_vm.orderNo) +
                                  "X" +
                                  _vm._s(index + 1)
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.type == 1 && index + 1 < 10
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "40px",
                                "margin-left": "2px",
                                color: "#4168E7",
                                "font-size": "14px",
                              },
                            },
                            [
                              _vm._v(
                                " 子订单编号：" +
                                  _vm._s(_vm.orderNo) +
                                  "-0" +
                                  _vm._s(index + 1)
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.type == 1 && index + 1 > 10
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "40px",
                                "margin-left": "2px",
                                color: "#4168E7",
                                "font-size": "14px",
                              },
                            },
                            [
                              _vm._v(
                                " 子订单编号：" +
                                  _vm._s(_vm.orderNo) +
                                  "-" +
                                  _vm._s(index + 1)
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.type == 0
                        ? _c("div", { staticClass: "splitType" }, [
                            _vm._v(" 拆单类型：母单"),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _vm.type == 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                "font-size": "14px",
                                "font-family": "PingFang SC",
                                "font-weight": "400",
                                "line-height": "40px",
                                color: "#333333",
                              },
                            },
                            [_vm._v(" 代收金额 ")]
                          )
                        : _vm._e(),
                      _vm.type == 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                "margin-top": "6px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入代收金额",
                                  size: "mini",
                                },
                                model: {
                                  value: item.collectAmount,
                                  callback: function ($$v) {
                                    _vm.$set(item, "collectAmount", $$v)
                                  },
                                  expression: "item.collectAmount",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            "margin-top": "4px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                color: "red",
                                border: "1px solid red",
                                width: "90px",
                                height: "28px",
                                "line-height": "10px",
                                "margin-top": "2px",
                              },
                              attrs: { plain: "", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteOrder(index)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    attrs: {
                      border: "",
                      data: item.goodsList,
                      "header-cell-style": {
                        background: "#FAFAFA",

                        color: "#303033",
                      },
                    },
                  },
                  [
                    _c(
                      "el-table-column",
                      {
                        attrs: { label: "商品", prop: "type", align: "left" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c("img", {
                                          staticStyle: {
                                            width: "106px",
                                            height: "80px",
                                          },
                                          attrs: { src: props.row.goodsImg },
                                        }),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "12px",
                                            flex: "1",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("el-input", {
                                                staticStyle: { height: "80px" },
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 3,
                                                },
                                                model: {
                                                  value: props.row.goodsName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      props.row,
                                                      "goodsName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "props.row.goodsName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "left" } },
                              [_vm._v("商品")]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      attrs: {
                        label: "商品规格",
                        prop: "type",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(_vm._s(props.row.goodsSkuName))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "数量", prop: "type", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "224px" },
                                      attrs: {
                                        size: "small",
                                        oninput:
                                          "value=value.replace(/^0|[^0-9]/g, '')",
                                        placeholder: "请输入数量",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.upDateNum(
                                            $event,
                                            index,
                                            props.$index,
                                            props.row
                                          )
                                        },
                                      },
                                      model: {
                                        value: props.row.quantity,
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "quantity", $$v)
                                        },
                                        expression: "props.row.quantity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", prop: "type", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168E7",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteD(
                                            index,
                                            props.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "aBtn",
                    staticStyle: { "margin-top": "16px" },
                    on: {
                      click: function ($event) {
                        return _vm.addShop(index)
                      },
                    },
                  },
                  [_vm._v("增加商品")]
                ),
              ],
              1
            )
          }),
          _c("div", { staticStyle: { height: "20px" } }),
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "start",
            "margin-top": "20px",
            "margin-bottom": "20px",
            "padding-bottom": "20px",
          },
        },
        [
          _c("div", { staticClass: "cBtn1", on: { click: _vm.back } }, [
            _vm._v("取消"),
          ]),
          _c(
            "div",
            {
              staticClass: "qBtn",
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v("确认")]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.dialogTableVisible,
            "append-to-body": "",
            width: "640px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "20px 30px" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "10px" },
                  attrs: {
                    border: "",
                    data: _vm.selectGoods,
                    "header-cell-style": {
                      background: "#FAFAFA",

                      color: "#303033",
                    },
                  },
                },
                [
                  _c(
                    "el-table-column",
                    {
                      attrs: { label: "商品名称", prop: "type", align: "left" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(props.row.originGoodsName)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("div", { staticStyle: { "text-align": "left" } }, [
                            _vm._v("商品名称"),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _c("el-table-column", {
                    attrs: { label: "商品规格", prop: "type", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(props.row.goodsSkuName))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "剩余数量", prop: "type", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _vm._v(" " + _vm._s(props.row.quantity) + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "选择拆单数量",
                      prop: "type",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "small",
                                    oninput:
                                      "value=value.replace(/^0|[^0-9]/g, '')",
                                    placeholder: "请输入数量",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.inputNum(
                                        $event,
                                        props.$index,
                                        props.row
                                      )
                                    },
                                  },
                                  model: {
                                    value: props.row.splitQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "splitQuantity", $$v)
                                    },
                                    expression: "props.row.splitQuantity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", prop: "type", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("el-checkbox", {
                              model: {
                                value: props.row.checked,
                                callback: function ($$v) {
                                  _vm.$set(props.row, "checked", $$v)
                                },
                                expression: "props.row.checked",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              width: "100%",
              height: "0px",
              border: "1px solid #D9D9D9",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "20px",
                "margin-bottom": "10px",
                "margin-right": "30px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "cBtn",
                  on: {
                    click: function ($event) {
                      _vm.dialogTableVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "div",
                {
                  staticClass: "qBtn",
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isFinish,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isFinish = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("温馨提示")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content", staticStyle: { padding: "20px 30px" } },
            [
              _vm.isContent
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "margin-top": "20px",
                        "margin-left": "30px",
                      },
                    },
                    [_vm._v("订单未完成拆单，请继续拆单！")]
                  )
                : _vm._e(),
              !_vm.isContent
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "margin-top": "20px",
                        "margin-left": "30px",
                      },
                    },
                    [
                      _vm._v("拆单订单填写的"),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("[代收金额]"),
                      ]),
                      _vm._v("总和不等于原订单，请修改填写!"),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "margin-top": "20px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cBtn",
                      on: {
                        click: function ($event) {
                          _vm.isFinish = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "qBtn",
                      on: {
                        click: function ($event) {
                          _vm.isFinish = false
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "删除拆单",
            visible: _vm.isDelete,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDelete = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("删除拆单")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content", staticStyle: { padding: "20px 30px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "margin-top": "20px",
                    "margin-left": "30px",
                  },
                },
                [
                  _vm._v("是否确认删除"),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v("[订单拆单]" + _vm._s(this.dIndex + 1)),
                  ]),
                  _vm._v("，删除后不可恢复数据!"),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "margin-top": "20px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cBtn",
                      on: {
                        click: function ($event) {
                          _vm.isDelete = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "qBtn",
                      on: {
                        click: function ($event) {
                          return _vm.cDeleterOrder()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }